interface MegaMenuProps {
  title: string;
}

const MegaMenuDemo = ({ title }: MegaMenuProps) => {
  return (
    <div className="container-fluid" id="megamenu">
      <div className="container">
        <div className="row pb-5">
          <div className="col-12 pt-4 pt-sm-4">
            <h1 className="megamenu-heading">{title}</h1>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <h3 className="mt-1 ps-2">Topic I</h3>
            <a title={'Topic'}>Topic</a>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <h3 className="mt-1 ps-2">Topic II</h3>
            <a title={'Topic'}>Topic II</a>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <h3 className="mt-1 ps-2">Topic III</h3>
            <a title={'Topic'}>Topic III</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenuDemo;
